import { createRouter, createWebHistory } from "vue-router";
import HomeIndex from "../components/sites/HomeIndex.vue";
import ImpressumIndex from "../components/sites/ImpressumIndex.vue";
import LoginIndex from "../components/sites/LoginIndex.vue";
import AdminTerminIndex from "../components/sites/admin/AdminTerminIndex.vue";
import AdminTerminDetail from "../components/sites/admin/AdminTerminDetail.vue";
import AdminMailIndex from "../components/sites/admin/AdminMailIndex.vue";
import { useUserStore } from "@/stores/userStore.js";

const routes = [
  { path: "/", name: "home", component: HomeIndex },
  { path: "/impressum", name: "impressum", component: ImpressumIndex },
  { path: "/login", name: "login", component: LoginIndex },
  {
    path: "/admin/termin",
    name: "admin-termin",
    component: AdminTerminIndex,
    meta: { requiresAdmin: true },
  },
  {
    path: "/admin/termin/:id(\\d+)",
    name: "admin-termin-detail",
    component: AdminTerminDetail,
    meta: { requiresAdmin: true },
  },
  {
    path: "/admin/mail",
    name: "admin-mail",
    component: AdminMailIndex,
    meta: { requiresAdmin: true },
  },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { el: to.hash, behavior: "smooth", top: 90 };
    return { top: 0 };
  },
});

router.beforeEach(async (to) => {
  if (!to.meta?.requiresAdmin) return true;

  const userStore = useUserStore();
  if (!userStore.loaded) {
    await userStore.fetchLoggedUser();
  }
  if (userStore.isAdmin) return true;

  return {
    name: "login",
    query: { redirect: to.fullPath },
  };
});

export default router;
